/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceSerialiser } from './EvidenceSerialiser';
import {
  EvidenceSerialiserFromJSON,
  EvidenceSerialiserFromJSONTyped,
  EvidenceSerialiserToJSON,
} from './EvidenceSerialiser';

/**
 *
 * @export
 * @interface PaginatedEvidenceSerialiserList
 */
export interface PaginatedEvidenceSerialiserList {
  /**
   *
   * @type {number}
   * @memberof PaginatedEvidenceSerialiserList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedEvidenceSerialiserList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedEvidenceSerialiserList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<EvidenceSerialiser>}
   * @memberof PaginatedEvidenceSerialiserList
   */
  results: Array<EvidenceSerialiser>;
}

/**
 * Check if a given object implements the PaginatedEvidenceSerialiserList interface.
 */
export function instanceOfPaginatedEvidenceSerialiserList(value: object): value is PaginatedEvidenceSerialiserList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedEvidenceSerialiserListFromJSON(json: any): PaginatedEvidenceSerialiserList {
  return PaginatedEvidenceSerialiserListFromJSONTyped(json, false);
}

export function PaginatedEvidenceSerialiserListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedEvidenceSerialiserList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(EvidenceSerialiserFromJSON),
  };
}

export function PaginatedEvidenceSerialiserListToJSON(value?: PaginatedEvidenceSerialiserList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(EvidenceSerialiserToJSON),
  };
}
